import { InputSkeleton } from '@/_components';
import {
  CardContainer,
  Container,
  ContainerLayout,
  FormLayout,
  LeftSection,
  StickyPageHeaderSkeletonWithButtons,
} from '@/_containers';
import { RichTextLoader } from '@/_containers/inputs/rich-text';

export default function Loading() {
  return (
    <ContainerLayout>
      <StickyPageHeaderSkeletonWithButtons numberOfButtons={2} />

      <Container>
        <LeftSection>
          <CardContainer>
            <FormLayout>
              <InputSkeleton className="col-span-12 sm:col-span-6 lg:col-span-4 2xl:col-span-4" />
              <InputSkeleton className="col-span-12 sm:col-span-6 lg:col-span-4 2xl:col-span-4" />
              <InputSkeleton className="col-span-12 sm:col-span-6 lg:col-span-4 2xl:col-span-4" />
              <InputSkeleton className="col-span-12 sm:col-span-6 lg:col-span-4 2xl:col-span-4" />
              <InputSkeleton className="col-span-12 sm:col-span-6 lg:col-span-4 2xl:col-span-4" />
              <InputSkeleton className="col-span-12 sm:col-span-6 lg:col-span-4 2xl:col-span-4" />
              <InputSkeleton className="col-span-12 sm:col-span-6 lg:col-span-4 2xl:col-span-4" />
              <InputSkeleton className="col-span-12 sm:col-span-6 lg:col-span-4 2xl:col-span-4" />
              <InputSkeleton className="col-span-12 sm:col-span-6 lg:col-span-4 2xl:col-span-4" />
              <InputSkeleton className="col-span-12 sm:col-span-6 lg:col-span-4 2xl:col-span-4" />
              <InputSkeleton className="col-span-12 sm:col-span-6 lg:col-span-4 2xl:col-span-4" />
              <InputSkeleton className="col-span-12 sm:col-span-6 lg:col-span-4 2xl:col-span-4" />
              <RichTextLoader inline withLabel className="col-span-12" />
            </FormLayout>
          </CardContainer>
        </LeftSection>
      </Container>
    </ContainerLayout>
  );
}
